import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MemberLayout } from "@/components/Layout";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function MyStatistics() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats/me").then(r => setStats(r.data)); }, []);

  if (!stats) return <MemberLayout title="Min statistik"><div className="text-slate-400 text-sm">Laddar…</div></MemberLayout>;

  return (
    <MemberLayout title="Min statistik">
      <div className="grid grid-cols-2 gap-3">
        <StatCard label="Totalt" value={stats.total_conversations} tid="stat-total"/>
        <StatCard label="Denna vecka" value={stats.week_conversations} tid="stat-week"/>
        <StatCard label="Denna månad" value={stats.month_conversations} tid="stat-month"/>
        <StatCard label="Aktiviteter" value={stats.total_activities} tid="stat-activities"/>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5 mt-4">
        <div className="text-xs uppercase tracking-widest font-semibold text-slate-500 mb-3">Senaste 30 dagarna</div>
        {stats.timeline.length > 0 ? (
          <div className="h-52">
            <ResponsiveContainer>
              <LineChart data={stats.timeline}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false}/>
                <XAxis dataKey="date" tick={{ fontSize: 10 }} tickFormatter={d => d.slice(5)}/>
                <YAxis tick={{ fontSize: 10 }} width={30}/>
                <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }}/>
                <Line type="monotone" dataKey="conversations" stroke="#E1251B" strokeWidth={2} dot={{ r: 3 }}/>
              </LineChart>
            </ResponsiveContainer>
          </div>
        ) : <div className="text-sm text-slate-400 py-10 text-center">Inga registreringar än.</div>}
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-5 mt-4">
        <div className="text-xs uppercase tracking-widest font-semibold text-slate-500 mb-3">Per plats</div>
        {stats.by_location.length > 0 ? (
          <div className="space-y-2">
            {stats.by_location.map(l => (
              <div key={l.location_id} className="flex justify-between items-center py-2 border-b border-slate-100 last:border-0" data-testid={`bloc-${l.location_name}`}>
                <span className="font-medium text-slate-900">{l.location_name}</span>
                <span className="font-heading font-bold text-slate-900 number-tabular">{l.conversations}</span>
              </div>
            ))}
          </div>
        ) : <div className="text-sm text-slate-400 text-center py-4">Inga platser än.</div>}
      </div>
    </MemberLayout>
  );
}

function StatCard({ label, value, tid }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={tid}>
      <div className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
      <div className="font-heading text-3xl font-extrabold text-slate-900 mt-1 number-tabular">{value}</div>
    </div>
  );
}
